module.exports = __webpack_public_path__ + "static/JHSPHLogo-07c339f4aa1fa5ecdb99926ef3ef7658.webp";